// eslint-disable-next-line
import { UserLayout, ViewsLayout, HomePageLayout } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const componentsLayzyMap = {
  ViewsLayout: ViewsLayout
  // design: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "design" */ '@/views/design/design')
}
export const constantRouterMap = [
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/affiliate/:token',
    name: 'affiliate',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/user/Login')
  },
  {
    path: '/Vn',
    redirect: '/Vn/fbactivity',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/activity/index'),
    children: [
      {
        path: 'fbactivity',
        name: 'fbactivity',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/user/Login')
      },
      {
        path: 'registerSuccess',
        name: 'registerSuccess',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/user/RegisterSuccess')
      }
    ]
  },
  {
    path: '/system',
    component: UserLayout,
    redirect: '/system/maintenance',
    hidden: true,
    children: [
      {
        path: 'maintenance',
        name: 'maintenance',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/maintenaPage')
      }
    ]
  },
  {
    path: '/other',
    component: UserLayout,
    redirect: '/other/producerInfo',
    hidden: true,
    children: [
      {
        path: 'producerInfo',
        name: 'producerInfo',
        component: () => import(/* webpackChunkName: "producerInfo" */ '@/views/producerInfo/producerInfo')
      }
    ]
  },
  {
    path: '/design',
    component: HomePageLayout,
    redirect: '/design/design',
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: 'design',
        name: 'design',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "design" */ '@/views/design/design')
      },
      {
        path: 'design/:code/:id',
        name: 'designParams',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "design" */ '@/views/design/design')
      }
    ]
  },
  {
    path: '/',
    component: HomePageLayout,
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/homePage/homePage')
      },
      {
        path: '/products',
        name: 'products',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      {
        path: '/products/:id',
        name: 'productDetail',
        component: () => import(/* webpackChunkName: "productDetail" */ '@/views/productDetail')
      },
      {
        path: '/products/category/:category',
        name: 'productsCategory',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      {
        path: '/products/special/:special',
        name: 'productsSpecial',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      {
        path: '/products/level/:level',
        name: 'productsLevel',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      {
        path: '/products/tag/:product_tag',
        name: 'productsTag',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      {
        path: '/products/brand/:is_brand',
        name: 'productsBrand',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      {
        path: '/products/timeliness/:timeliness',
        name: 'productsTimeliness',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      {
        path: '/products/favorites/:isFavorites',
        name: 'productsFavorites',
        component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      },
      // {
      //   path: '/presetProduct',
      //   name: 'presetProduct',
      //   component: () => import(/* webpackChunkName: "products" */ '@/views/products')
      // },
      {
        path: '/presetProduct/:id',
        name: 'presetProductDetail',
        component: () =>
          import(/* webpackChunkName: "presetProductDetail" */ '@/views/presetProduct/presetProductDetail')
      },
      {
        path: '/cart',
        name: 'cart',
        component: () => import(/* webpackChunkName: "cart" */ '@/views/cart')
      },
      // {
      //   path: '/home/productDesign',
      //   name: 'productDesign',
      //   component: () => import(/* webpackChunkName: "productDesign" */ '@/views/productDesign/productDesign')
      // },
      // {
      //   path: '/home/productDesignDetail',
      //   name: 'productDesignDetail',
      //   component: () =>
      //     import(/* webpackChunkName: "productDesignDetail" */ '@/views/productDesign/productDesignDetail')
      // },
      // {
      //   path: '/home/adSpecial',
      //   name: 'adSpecial',
      //   component: () => import(/* webpackChunkName: "propaganda" */ '@/views/productDesign/adSpecial.vue')
      // },
      {
        path: '/home/blog',
        name: 'blog',
        component: () => import(/* webpackChunkName: "propaganda" */ '@/views/blog/index.vue')
      },
      {
        path: '/holiday',
        name: 'holiday',
        component: () => import(/* webpackChunkName: "propaganda" */ '@/views/holiday/index.vue')
      },
      {
        path: '/newcomer-gift',
        name: 'newcomerGift',
        component: () => import(/* webpackChunkName: "newcomer-gift" */ '@/views/newcomerGift')
      },
      {
        path: '/activity/easter',
        name: 'easter',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/easter.vue')
      },
      {
        path: '/activity/motherIsDay',
        name: 'motherIsDay',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/motherIsDay.vue')
      },
      {
        path: '/activity/graduationSale',
        name: 'graduationSale',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/graduationSale.vue')
      },
      {
        path: '/activity/allOverPrint',
        name: 'allOverPrint',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/allOverPrint.vue')
      },
      {
        path: '/activity/fatherIsDay',
        name: 'fatherIsDay',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/fatherIsDay.vue')
      },
      {
        path: '/activity/metalSignCustom',
        name: 'metalSignCustom',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/metalSignCustom.vue')
      },
      {
        path: '/copyright_notice',
        name: 'copyrightNotice',
        component: () => import(/* webpackChunkName: "copyrightNotice" */ '@/views/copyrightNotice/index.vue')
      },
      {
        path: '/activity/hawaiianBeachStyle',
        name: 'hawaiianBeachStyle',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/hawaiianBeachStyle.vue')
      },
      {
        path: '/activity/halloweenCustomization',
        name: 'halloweenCustomization',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/halloweenCustomization.vue')
      },
      {
        path: '/activity/halloween',
        name: 'halloween',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/halloween.vue')
      },
      {
        path: '/activity/customChristmas',
        name: 'customChristmas',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/customChristmas.vue')
      },
      {
        path: '/activity/uniqueLove',
        name: 'uniqueLove',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/uniqueLove.vue')
      },
      {
        path: '/activity/stPatrickIsDay',
        name: 'stPatrickIsDay',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/stPatrickIsDay.vue')
      },
      {
        path: '/activity/easterGiftZone',
        name: 'easterGiftZone',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/easterGiftZone.vue')
      },
      {
        path: '/activity/bestSellersForSummer',
        name: 'bestSellersForSummer',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/bestSellersForSummer.vue')
      },
      {
        path: '/activity/HalloweenParty',
        name: 'letThePartyBegin',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/letThePartyBegin.vue')
      },
      {
        path: '/activity/worldCup',
        name: 'worldCup',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/christmas/worldCup.vue')
      },
      {
        path: '/coupon',
        name: 'homeCoupon',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCoupon/index.vue')
      },
      {
        path: '/transfer',
        name: 'homeTransfer',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCoupon/transfer.vue')
      },
      {
        path: '/customService',
        name: 'customService',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/customService.vue')
      },
      {
        path: '/brandService',
        name: 'brandService',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/brandService.vue')
      },
      {
        path: '/dropshipping',
        name: 'dropshipping',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/dropshipping.vue')
      },
      {
        path: '/bulkShipping',
        name: 'bulkShipping',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/bulkShipping.vue')
      },
      {
        path: '/groupBuyingService',
        name: 'groupBuyingService',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/groupBuyingService.vue')
      },
      {
        path: '/freeSample',
        name: 'freeSample',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/freeSample.vue')
      },
      {
        path: '/bulkOrderService',
        name: 'bulkOrderService',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/bulkOrderService.vue')
      },
      {
        path: '/vnvip',
        name: 'vnBulkOrderService',
        component: () => import(/* webpackChunkName: "christmas" */ '@/views/homeCollect/vn-blukorderservice.vue')
      }
    ]
  },
  {
    path: '/personal_center',
    component: ViewsLayout,
    redirect: '/personal_center/guide',
    children: [
      {
        path: '/personal_center/guide',
        name: 'main',
        component: () => import(/* webpackChunkName: "main" */ '@/views/main/main')
      },
      {
        path: '/personal_center/orderList',
        name: 'order',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order')
      },
      {
        path: '/personal_center/orderImport',
        name: 'orderImport',
        component: () => import(/* webpackChunkName: "orderImport" */ '@/views/orderImport')
      },
      {
        path: '/personal_center/batchPayment',
        name: 'batchPayment',
        component: () => import(/* webpackChunkName: "orderImport" */ '@/views/batchPayment')
      },
      {
        path: '/personal_center/orderEdit',
        name: 'orderEdit',
        component: () => import(/* webpackChunkName: "orderEdit" */ '@/views/orderEdit')
      },
      {
        path: '/personal_center/orderItemEdit',
        name: 'orderItemEdit',
        component: () => import(/* webpackChunkName: "orderItemEdit" */ '@/views/orderItemEdit')
      },
      {
        path: '/personal_center/billing',
        name: 'billing',
        component: () => import(/* webpackChunkName: "billing" */ '@/views/billing')
      },
      {
        path: '/personal_center/productTemplate',
        name: 'productTemplate',
        component: () => import(/* webpackChunkName: "productTemplate" */ '@/views/productTemplate')
      },
      {
        path: '/personal_center/publish',
        name: 'publish',
        component: () => import(/* webpackChunkName: "productTemplate" */ '@/views/productTemplate/publish.vue')
      },
      {
        path: '/personal_center/productPublish',
        name: 'productPublish',
        component: () => import(/* webpackChunkName: "productTemplate" */ '@/views/productTemplate/productPublish.vue')
      },
      {
        path: '/personal_center/productPublish/:id',
        name: 'productPublish',
        component: () => import(/* webpackChunkName: "productTemplate" */ '@/views/productTemplate/productPublish.vue')
      },
      {
        path: '/personal_center/printFiles',
        name: 'printFiles',
        component: () => import(/* webpackChunkName: "printFiles" */ '@/views/printFiles')
      },
      {
        path: '/checkout',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "checkout" */ '@/views/checkout')
      },
      {
        path: '/personal_center/stores',
        name: 'stores',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/stores')
      },
      {
        path: '/personal_center/newStores',
        name: 'newStores',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/newStores')
      },
      {
        path: '/personal_center/coupon',
        name: 'coupon',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/coupon')
      },
      {
        path: '/personal_center/file',
        name: 'file',
        component: () => import(/* webpackChunkName: "file" */ '@/views/file')
      },
      {
        path: '/personal_center/apply',
        name: 'apply',
        component: () => import(/* webpackChunkName: "affiliateProgramApply" */ '@/views/apply')
      },
      {
        path: '/personal_center/withdrawal',
        name: 'withdrawal',
        component: () => import(/* webpackChunkName: "withdrawal" */ '@/views/withdrawal')
      },
      {
        path: '/personal_center/accountDetails',
        name: 'accountDetails',
        component: () => import(/* webpackChunkName: "accountDetails" */ '@/views/accountDetails')
      },
      {
        path: '/personal_center/addressBook',
        name: 'addressBook',
        component: () => import(/* webpackChunkName: "addressBook" */ '@/views/addressBook')
      },
      {
        path: '/personal_center/affiliateProgram',
        name: 'affiliateProgram',
        component: () => import(/* webpackChunkName: "affiliateProgram" */ '@/views/affiliateProgram')
      },
      {
        path: '/personal_center/iossNumber',
        name: 'iossNumber',
        component: () => import(/* webpackChunkName: "iossNumber" */ '@/views/iossNumber')
      },
      {
        path: '/thirdProduct/:id',
        name: 'thirdProduct',
        component: () => import(/* webpackChunkName: "thirdProduct" */ '@/views/thirdProduct')
      },
      {
        path: '/newThirdProduct/:id',
        name: 'newThirdProduct',
        component: () => import(/* webpackChunkName: "thirdProduct" */ '@/views/thirdProduct/newThirdProduct.vue')
      },
      {
        path: '/personal_center/amazon_export',
        name: 'amazonExport',
        component: () => import(/* webpackChunkName: "amazon_export" */ '@/views/amazonExport')
      },
      {
        path: '/systemNotice',
        name: 'systemNotice',
        component: () => import(/* webpackChunkName: "systemNotice" */ '@/views/systemNotice')
      },
      {
        path: '/systemNotice/:id',
        name: 'systemNoticeDetail',
        component: () => import(/* webpackChunkName: "systemNotice" */ '@/views/systemNoticeDetail')
      },
      {
        path: '/personal_center/brand',
        name: 'brand',
        component: () => import(/* webpackChunkName: "systemNotice" */ '@/views/brand')
      },
      {
        path: '/personal_center/brand/:type',
        name: 'brandType',
        component: () => import(/* webpackChunkName: "systemNotice" */ '@/views/brand')
      },
      {
        path: '/personal_center/payDetail',
        name: 'payDetail',
        component: () => import(/* webpackChunkName: "systemNotice" */ '@/views/payDetail')
      },
      {
        path: '/personal_center/myFavorites',
        name: 'myFavorites',
        component: () => import(/* webpackChunkName: "systemNotice" */ '@/views/myFavorites')
      },
      {
        path: '/personal_center/myWallet',
        name: 'myWallet',
        component: () => import(/* webpackChunkName: "systemNotice" */ '@/views/myWallet')
      }
    ]
  },
  {
    path: '/staticPage',
    component: HomePageLayout,
    redirect: '/staticPage/about_us',
    children: [
      {
        path: '/about_us',
        name: 'aboutUs',
        component: () => import(/* webpackChunkName: "aboutUs" */ '@/views/static/aboutUs')
      },
      {
        path: '/how-it-work',
        name: 'aboutUsNext',
        component: () => import(/* webpackChunkName: "aboutUsNext" */ '@/views/static/aboutUsNext')
      },
      {
        path: '/terms_of_service',
        name: 'serviceDesc',
        component: () => import(/* webpackChunkName: "serviceDesc" */ '@/views/static/serviceDesc')
      },
      {
        path: '/bulk_order_works',
        name: 'serviceDescNext',
        component: () => import(/* webpackChunkName: "serviceDescNext" */ '@/views/static/serviceDescNext')
      },
      {
        path: '/contact_us',
        name: 'connectUs',
        component: () => import(/* webpackChunkName: "connectUs" */ '@/views/static/connectUs')
      },
      {
        path: '/privacy_policy',
        name: 'privacyPolicy',
        component: () => import(/* webpackChunkName: "privacyPolicy" */ '@/views/static/privacyPolicy')
      },
      {
        path: '/affiliate-program',
        name: 'affiliateIntroduction',
        component: () => import(/* webpackChunkName: "affiliateIntroduction" */ '@/views/static/affiliateProgram')
      },
      {
        path: '/affiliate-lessons',
        name: 'affiliateLessons',
        component: () => import(/* webpackChunkName: "affiliateLessons" */ '@/views/static/affiliateLessons')
      },
      {
        path: '/helpcenter',
        name: 'helpCenter',
        component: () => import(/* webpackChunkName: "main" */ '@/views/helpCenter')
      },
      {
        path: '/helpcenter/:category_id',
        name: 'helpCenterC',
        component: () => import(/* webpackChunkName: "main" */ '@/views/helpCenter')
      },
      {
        path: '/helpcenter/:category_id/:article_id',
        name: 'helpCenterCA',
        component: () => import(/* webpackChunkName: "main" */ '@/views/helpCenter')
      },
      {
        path: '/shipping',
        name: 'shipping',
        component: () => import(/* webpackChunkName: "shipping" */ '@/views/static/shipping')
      },
      {
        path: '/refund_policy',
        name: 'refundPolicy',
        component: () => import(/* webpackChunkName: "refundPolicy" */ '@/views/static/refundPolicy')
      },
      {
        path: '/print_on_demand',
        name: 'printOnDemand',
        component: () => import(/* webpackChunkName: "printOnDemand" */ '@/views/static/printOnDemand')
      },
      {
        path: '/timeliness',
        name: 'timeliness',
        component: () => import(/* webpackChunkName: "printOnDemand" */ '@/views/static/timeliness')
      }
    ]
  },
  {
    path: '/platform',
    redirect: '/etsy',
    component: HomePageLayout,
    children: [
      {
        path: '/etsy',
        name: 'etsy',
        component: () => import(/* webpackChunkName: "platform-etsy" */ '@/views/platformPage/etsy')
      },
      {
        path: '/shopify',
        name: 'shopify',
        component: () => import(/* webpackChunkName: "platform-shopify" */ '@/views/platformPage/shopify')
      },
      {
        path: '/wooCommerce',
        name: 'wooCommerce',
        component: () => import(/* webpackChunkName: "platform-wooCommerce" */ '@/views/platformPage/wooCommerce')
      },
      {
        path: '/shoplazza',
        name: 'shoplazza',
        component: () => import(/* webpackChunkName: "platform-shoplazza" */ '@/views/platformPage/shoplazza')
      }
    ]
  },
  {
    path: '/airwallex',
    component: () => import(/* airwallex 支付 */ '@/views/airwallex/index.vue')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403')
    // redirect: '/home/homePage'
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
    // redirect: '/home/homePage'
  }
]
